
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Our documentation site has moved to pxblue.github.io. We're also bringing testing to the forefront and adding unit tests to all of our resources. Plus new design patterns and examples for Bottom Sheets and Steppers.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;